import { DemoExample } from "@/components/sections/DemoSection";

export const animalEditingDemo: DemoExample = {
    label: "Animal Editing",
    beforeImage: "/images/demos/animal-demo/animal-demo-before.webp",
    beforeImageSrcSet: "/images/demos/animal-demo/animal-demo-before-400w.webp 400w, /images/demos/animal-demo/animal-demo-before-800w.webp 800w, /images/demos/animal-demo/animal-demo-before-1200w.webp 1200w",
    afterImage: "/images/demos/animal-demo/animal-demo-after.webp",
    afterImageSrcSet: "/images/demos/animal-demo/animal-demo-after-400w.webp 400w, /images/demos/animal-demo/animal-demo-after-800w.webp 800w, /images/demos/animal-demo/animal-demo-after-1200w.webp 1200w",
    title: "Remove Person & Change Dog Background to Park",
    description: "Remove the person from the photo and transform your dog's background from an indoor couch to an outdoor park.",
    alt: "Before and after removing person and changing dog background from indoor couch to outdoor park"
};
